const candidateTypes = {
    FETCH_CANDIDATE_EVENT_DATA:'FETCH_CANDIDATE_EVENT_DATA',
    FETCH_DOCUMENT_TYPES:"FETCH_DOCUMENT_TYPES",
    SET_CANDIDATE_LOCATION:"SET_CANDIDATE_LOCATION",
    STORE_UPLOADED_FILE:"STORE_UPLOADED_FILE"
}
export default candidateTypes;
